// import { ref } from 'vue'
// import { useI18n } from 'vue-i18n'
import { ProtectedRoute } from '../../config/permissions'

export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; disallowClients?: boolean }
  children?: INavigationRoute[]
}
export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: ProtectedRoute.DASHBOARD,
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: ProtectedRoute.MY_ORGANIZATION,
      displayName: 'menu.my-organization',
      meta: {
        icon: 'business',
        disallowClients: true,
      },
      children: [
        {
          name: ProtectedRoute.USER_MANAGEMENT,
          displayName: 'menu.userManagement',
          meta: { icon: '', disallowClients: true } as any,
        },
        {
          name: ProtectedRoute.ORGANIZATION_STATS,
          displayName: 'menu.organizationStats',
          meta: { icon: '', disallowClients: true } as any,
        },
        {
          name: ProtectedRoute.ORGANIZATION_SETTINGS,
          displayName: 'menu.organizationSettings',
          meta: { icon: '', disallowClients: true } as any,
        },
      ],
    },
    {
      name: ProtectedRoute.PROJECTS,
      displayName: 'menu.projects',
      meta: {
        icon: 'folder_shared',
      },
    },
    {
      name: ProtectedRoute.ODK_SERVERS,
      displayName: 'menu.odkServers',
      meta: {
        icon: 'dns',
      },
    },
    {
      name: ProtectedRoute.ODK_SYNC,
      displayName: 'menu.odkSync',
      meta: {
        icon: 'sync',
      },
    },
    {
      name: ProtectedRoute.PREFERENCES,
      displayName: 'menu.preferences',
      meta: {
        icon: 'manage_accounts',
      },
    },
    {
      name: ProtectedRoute.FAQ,
      displayName: 'menu.help',
      to: { name: ProtectedRoute.FAQ },
      meta: {
        icon: 'quiz',
      },
    },
    {
      name: ProtectedRoute.SETTINGS,
      displayName: 'menu.settings',
      meta: {
        icon: 'settings',
      },
    },
  ] as INavigationRoute[],
}
